export default function MySQL_UNION() {
  return (
    <div>
      <h2>MySQL_UNION</h2>    </div>
  );
}